module.exports = __webpack_public_path__ + "static/media/eye.b96cf204.png";